const tokensPT = {
    "view": {
        "title": "Historico de tokens",
        "table": {
            "column": {
                "quantity": "Quantidade",
                "description": "Descricao",
                "type": "Tipo",
                "balance": "Saldo",
                "date": "Data",
                "receipt": "Recibo"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "button": {
                "view": "Ver",
                "export_csv": "Exportar CSV",
                "order_tokens": "Pedir tokens"
            },
            "label": {
                "not_available": "Nao disponivel",
                "credit": "Credito",
                "debit": "Debito"
            }
        }
    },
    "order": {
        "title": "Pedir tokens",
        "form": {
            "label": {
                "quantity": "Quantidade"
            },
            "placeholder": {
                "quantity": "Selecione a quantidade"
            },
            "help": {
                "quantity": "Quantidade de tokens que voce deseja pedir."
            },
            "validation": {
                "quantityRequired": "A quantidade e obrigatoria"
            },
            "button": {
                "placeOrder": "Fazer pedido"
            },
            "option": {
                "tokensAmount": "{{count}} tokens"
            }
        },
        "modal": {
            "title": "Prosseguir para o pagamento",
            "orderedPrefix": "Voce pediu",
            "description": "Se quiser confirmar o pedido, prossiga para o pagamento. Caso contrario, voce pode cancelar o pedido.",
            "button": {
                "cancel": "Cancelar",
                "checkout": "Pagar"
            }
        },
        "message": {
            "error": "Algo deu errado! Atualize a pagina e tente novamente!"
        }
    },
    "transaction": {
        "success": {
            "title": "Transacao concluida :)",
            "description": "Voce comprou os tokens com sucesso e eles serao adicionados em breve a sua conta!"
        },
        "cancel": {
            "title": "Transacao cancelada :(",
            "description": "A transacao foi cancelada... Tente novamente mais tarde!"
        },
        "button": {
            "returnToDashboard": "Voltar ao painel"
        }
    }
};

export default tokensPT;
